import { cn, Em } from '@scatterlab/zeta-core';

import { MarkdownComponents } from '../markdownComponents';
import { BUBBLE_THEME_CLASS_NAMES, BubbleTheme } from './bubble-theme';

export const ThemedMarkdownComponents = (
  theme: BubbleTheme = BubbleTheme.DEFAULT,
  isMine: boolean = false,
): typeof MarkdownComponents => ({
  ...MarkdownComponents,
  em: ({ children, node, ...props }) => (
    <Em
      className={cn(
        'pr-1 leading-[1.3em]',
        BUBBLE_THEME_CLASS_NAMES[theme][isMine ? 'mine' : 'character']
          .instructionText,
      )}
      {...props}
    >
      {children}
    </Em>
  ),
});
